import { createSlice } from '@reduxjs/toolkit'
import { listUIInitialState } from '@utils/constants/requestConstants'
import cloneDeep from 'lodash/cloneDeep'
import { listUIReducers } from '../reducers'
const matchingSelectionContactsSlice = createSlice({
    name: 'ui/matching-selection-contacts',
    initialState: {
        ...listUIInitialState,
        pagination: {
            ...listUIInitialState.pagination,
            itemsPerPage: 6
        },
        selectedRowKeys: {}
    },
    reducers: {
        ...listUIReducers,
        onChangeSelectedRows(state, action) {
            state.selectedRowKeys[action.payload.key] = action.payload.data
        },
        onRemoveSelectedRows(state, action) {
            const newSelectedRowKeys = cloneDeep(state.selectedRowKeys)
            delete newSelectedRowKeys[action.payload]
            state.selectedRowKeys = newSelectedRowKeys
        },
        onResetFilters(state) {
            state.filters = {}
            const newPopulates = cloneDeep(state.populates)
            newPopulates.filter(x => x.match).forEach(item => delete item.match)
            state.populates = newPopulates
            state.pureFilters = {}
        }
    }
})

export const matchingSelectionContactsActions = matchingSelectionContactsSlice.actions
export default matchingSelectionContactsSlice.reducer
